import { createContext, useContext } from 'react';

const TabsContext = createContext({ value: '', onValueChange: () => {} });

export function Tabs({ value, defaultValue, onValueChange, children, className = '' }) {
  const current = value ?? defaultValue ?? '';
  return (
    <TabsContext.Provider value={{ value: current, onValueChange }}>
      <div className={className}>{children}</div>
    </TabsContext.Provider>
  );
}

export function TabsList({ className = '', children }) {
  return <div className={className}>{children}</div>;
}

export function TabsTrigger({ value, className = '', children }) {
  const { value: active, onValueChange } = useContext(TabsContext);
  const isActive = active === value;
  return (
    <button
      type="button"
      onClick={() => onValueChange?.(value)}
      className={className}
      data-state={isActive ? 'active' : 'inactive'}
    >
      {children}
    </button>
  );
}

/**
 * @param {boolean} [keepMounted] — if true, inactive tab content stays in DOM (hidden) so effects/state sync on load.
 */
export function TabsContent({ value, className = '', children, keepMounted = false }) {
  const { value: active } = useContext(TabsContext);
  const visible = active === value;
  if (!keepMounted && !visible) return null;
  return (
    <div className={className} hidden={!visible}>
      {children}
    </div>
  );
}
